import { filter } from 'lodash'
import * as Sentry from '@sentry/react'

import StripeForm from './stripe_form.js'

class FormWithCardElements extends StripeForm {
  constructor(options = {}) {
    super(options)
    // set up extra default options (in addition to those set up by super class constructor)
    Object.assign(
      this,
      {
        cardElementQuerySelector: '.js-card-element',
        addressQuerySelector: '.js-address',
        cardTokenQuerySelector: '.js-stripe_card_token',
      },
      options
    )
  }

  init() {
    this.storeReferences()
    if (this.referencesValid()) {
      const submitButton = this.$form.querySelector(this.submitQuerySelector)
      this.enabledSubmitButtonValue = submitButton.value

      this.initCardElement()
      this.updatePaymentErrors()

      this.$form.addEventListener('submit', this.handleSubmit)
    } else {
      throw new Error('There are missing references')
    }
  }

  storeReferences() {
    super.storeReferences()
    this.$cardElement = this.$form.querySelector(this.cardElementQuerySelector)
    this.$billingAddress = this.$form.querySelector(this.addressQuerySelector)
    this.$cardTokenInput = this.$form.querySelector(this.cardTokenQuerySelector)
  }

  handleCardChange = event => {
    if (event.error) {
      this.paymentErrors = [event.error.message]
    } else {
      this.paymentErrors = []
    }
    this.updatePaymentErrors()
  }

  handleSubmit = event => {
    event.preventDefault()

    this.disableSubmit()
    const additionalTokenData = this.getTokenData()

    const responseHandler = res => {
      if (res.error) {
        this.paymentErrors = [res.error.message]
        this.updatePaymentErrors()
        this.enableSubmit()
      } else {
        this.paymentErrors = []
        this.updatePaymentErrors()
        this.submitFormWithToken(res.token)
      }
    }
    const errorHandler = err => {
      Sentry.captureException(err)
    }
    this.stripe.createToken(this.stripeCard, additionalTokenData).then(responseHandler, errorHandler)
  }

  submitFormWithToken(token) {
    // Insert the token ID into the form so it gets submitted to the server
    this.$cardTokenInput.setAttribute('value', token.id)
    // Submit the form
    this.$form.submit()
  }

  initCardElement() {
    const elements = this.stripe.elements()
    const card = elements.create('card', { style: this.getCardStyle() })
    card.mount(this.$cardElement)
    card.addEventListener('change', this.handleCardChange)
    this.stripeCard = card
  }

  getCardStyle() {
    return {
      base: {
        color: '#57575c',
        fontSize: '16px',
        fontFamily: 'Helvetica, Arial, sans-serif',
        fontSmoothing: 'antialiased',
        '::placeholder': {
          color: '#8f8f8f',
        },
      },
      invalid: {
        color: '#ff0000',
      },
    }
  }

  getTokenData() {
    return {
      name: this.$form.querySelector('.js-card-name').value,
    }
  }

  referencesValid() {
    const missingReferences = this.getMissingReferences()
    if (missingReferences.length > 0) {
      console.error('We have undefined references:', missingReferences)
      return false
    }
    return true
  }

  getRequiredReferences() {
    return ['stripe', '$cardElement', '$paymentErrorExplanation']
  }

  getMissingReferences() {
    const expected = this.getRequiredReferences()
    return filter(expected, elString => !this[elString])
  }
}

export default FormWithCardElements
